export default[
    //选择银行卡
    {
        path:'/card',
        name:'cardlist',
        meta:{
            title:'Banco'
        },
        component:()=>import('@/prestamate/views/card/list/index')
    },
    //添加银行卡
    {
        path:'/card/add',
        name:'bindcard',
        meta:{
            title:'Añadir una tarjeta bancaria'
        },
        component:()=>import('@/prestamate/views/card/add/index')
    },
    //订单页面
    {
        path:'/order',
        name:'order',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/prestamate/views/order/index/index')
    },
    //展期订单
    {
        path:'/order/delayed/:orderId',
        name:'orderDelayed',
        meta:{
            title:'Extensión de pago'
        },
        component:()=>import('@/prestamate/views/order/delayed/index')
    },
    //历史订单列表
    {
        path:'/order/history',
        name:'orderhistory',
        meta:{
            title:'Pedidos históricos'
        },
        component:()=>import('@/prestamate/views/order/history/index')
    },
    //历史订单详情
    {
        path:'/order/history/details/:orderId',
        name:'orderdetails',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/prestamate/views/order/details/index')
    },
    //完成订单
    {
        path:'/order/detail/:orderId/:loanTenureType/:curInstallment',
        name:'detail',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/prestamate/views/order/successes/index')
    },
    //android-客服
    {
        path:'/customer/index',
        name:'customerAndroid',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/prestamate/views/customer/android/index')
    },
    //IOS-客服
    {
        path:'/customer/ios',
        name:'customerIos',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/prestamate/views/customer/ios/index')
    },
    //借款协议
    {
        path:'/agreement',
        name:'agreementIndex',
        meta:{
            title:'Acuerdo de Préstamo Personal'
        },
        component:()=>import('@/prestamate/views/agreement/index/index.vue')
    },
    //FAQ常见问题
    {
        path:'/faq',
        name:'faqIndex',
        meta:{
            title:'FAQ'
        },
        component:()=>import('@/prestamate/views/faq/index/index.vue')
    },
]



// WEBPACK FOOTER //
// ./src/prestamate/router/router.js